import { DeviceLinkStatusDto } from '../api/dto/installation-status.dto'
import { CoreDeviceStatus, DeviceLinkStates, PvGeneratingStatus } from '../types'

export const summarizeDeviceLinks = (links: DeviceLinkStatusDto[]): DeviceLinkStates => {
  const hasError = (getValue: (link: DeviceLinkStatusDto) => CoreDeviceStatus | undefined): CoreDeviceStatus | undefined => {
    const values = links.map(getValue).filter((v): v is CoreDeviceStatus => v !== undefined)
    if (values.length === 0) return undefined
    return values.includes('error') ? 'error' : 'ok'
  }

  return {
    offline: hasError(link => link.states.offline),
    pvState: hasError(link => link.states.pvState),
    pvGenerating: getPvGeneratingStatus(links),
    batState: hasError(link => link.states.batState),
    gridState: hasError(link => link.states.gridState),
    wallbox: hasError(link => link.states.wallbox),
    batSoc: (() => {
      const nonNullValues = links.map(link => link.states.soc).filter((v): v is number => v !== null)
      return nonNullValues.length > 0
        ? transformPercentageToValue(Math.round(nonNullValues.reduce((sum, v) => sum + v, 0) / nonNullValues.length))
        : null
    })(),
  }
}

export const transformPercentageToValue = (percentage: number): number => {
  if (percentage < 0) return 0
  if (percentage > 100) return 1
  return percentage / 100
}

export const getPvGeneratingStatus = (links: DeviceLinkStatusDto[]): PvGeneratingStatus | undefined => {
  const pvGeneratingValues = links.map(link => link.states.pvGenerating).filter((v): v is PvGeneratingStatus => v !== undefined)
  if (pvGeneratingValues.length === 0) return undefined
  return pvGeneratingValues.includes('generating') ? 'generating' : 'not-generating'
}
